import React, { forwardRef } from 'react'
import { useMediaQuery } from 'react-responsive'
import { NavLink as RouterLink } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles'
import { Container, Typography, TextField, Button, CircularProgress, Snackbar, Slide } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert';
import LogoImg from "../../assets/images/ericssonWhite.png";
import { IAMAction } from '../../actions';
import { UnapprovedUser, LockedUser } from "../common";

const CustomRouterLink = forwardRef((props, ref) => (
    <div ref={ref} style={{ flexGrow: 1 }}>
        <RouterLink {...props} />
    </div>
));

const responsiveData = () => {
    let desktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' })
    let tablet = useMediaQuery({ query: '(max-width: 768px)' })
    let notMobile = useMediaQuery({ query: '(min-width: 450px)' })
    let mobile = useMediaQuery({ query: '(max-width: 450px)' })
    let portrait = useMediaQuery({ query: '(orientation: portrait)' })

    return { isDesktopOrLaptop: desktopOrLaptop, isTablet: tablet && notMobile, isMobile: mobile, isPortrait: portrait }
}

const ForgotPasswordDesktop = ({ profile, missing, username, setusername, userToken, setUsertoken, onResetPassword }) => {
    const classes = makeStyles((theme) => ({
        paper: {
            marginTop: theme.spacing(15),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        description: {
            padding: '20px',
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        avatar: {
            margin: theme.spacing(4),
            height: theme.spacing(12),
            width: theme.spacing(12),
        },
        content: {
            width: "100%",
            marginTop: theme.spacing(5),
        },
        button: {
            margin: theme.spacing(2, 0, 0),
        },
    }))()

    return (
        <React.Fragment>
            <Container component="main" maxWidth="xs">
                <div className={classes.paper}>
                    <img className={classes.avatar} src={LogoImg} />
                    <Typography variant="h3" color='textSecondary'>Ericsson Support Portal</Typography>
                    <div className={classes.content}>
                        <TextField autoFocus required fullWidth variant="outlined" margin="normal" type='text' id="username" label="Username or Email" error={missing['username']} value={username} onChange={(event) => setusername(event.target.value)} onKeyPress={(e) => { e.key === 'Enter' ? document.getElementById('usertoken').focus() : null }} />
                        <TextField autoFocus required fullWidth variant="outlined" margin="normal" type='number' id="usertoken" label="Authenticator Token" error={missing['token']} value={userToken} onChange={(event) => setUsertoken(event.target.value)} onKeyPress={(e) => { e.key === 'Enter' ? onResetPassword() : null }} />
                        <Button fullWidth variant="contained" className={classes.button} disabled={profile.status === 'WORKING'} startIcon={profile.status === 'WORKING' ? <CircularProgress size={20} /> : null} onClick={onResetPassword}><Typography variant="h5" style={{ color: profile.status === 'WORKING' ? '#FFFFFF' : '#000000' }}>Reset Password</Typography></Button>
                        <Button fullWidth variant="contained" className={classes.button} component={CustomRouterLink} to={"/login"} ><Typography variant="h5" style={{ color: '#000000' }}>Back to login</Typography></Button>
                    </div>
                </div>
            </Container>
            <div className={classes.paper}>
                <div className={classes.description}>
                    <Typography variant='h4' color='textSecondary'>**You will receive an email with your new password</Typography>
                    <Typography variant='h4' color='textSecondary'>once you receive your new password, a password reset is mandatory</Typography>
                </div>
            </div>
        </React.Fragment>
    )
}

const ForgotPasswordTablet = ({ profile, missing, username, setusername, userToken, setUsertoken, onResetPassword }) => {
    const classes = makeStyles((theme) => ({
        paper: {
            marginTop: theme.spacing(10),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        description: {
            padding: '20px',
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        avatar: {
            margin: theme.spacing(4),
            height: theme.spacing(12),
            width: theme.spacing(12),
        },
        content: {
            width: "100%",
            marginTop: theme.spacing(5),
        },
        button: {
            margin: theme.spacing(2, 0, 0),
        },
    }))()

    return (
        <React.Fragment>
            <Container component="main" maxWidth="xs">
                <div className={classes.paper}>
                    <img className={classes.avatar} src={LogoImg} />
                    <Typography variant="h3" color='textSecondary'>Ericsson Support Portal</Typography>
                    <div className={classes.content}>
                        <TextField autoFocus required fullWidth variant="outlined" margin="normal" type='text' id="username" label="Username or Email" error={missing['username']} value={username} onChange={(event) => setusername(event.target.value)} onKeyPress={(e) => { e.key === 'Enter' ? document.getElementById('usertoken').focus() : null }} />
                        <TextField autoFocus required fullWidth variant="outlined" margin="normal" type='number' id="usertoken" label="Authenticator Token" error={missing['token']} value={userToken} onChange={(event) => setUsertoken(event.target.value)} onKeyPress={(e) => { e.key === 'Enter' ? onResetPassword() : null }} />
                        <Button fullWidth variant="contained" className={classes.button} disabled={profile.status === 'WORKING'} startIcon={profile.status === 'WORKING' ? <CircularProgress size={20} /> : null} onClick={onResetPassword}><Typography variant="h5" style={{ color: profile.status === 'WORKING' ? '#FFFFFF' : '#000000' }}>Reset Password</Typography></Button>
                        <Button fullWidth variant="contained" className={classes.button} component={CustomRouterLink} to={"/login"} ><Typography variant="h5" style={{ color: '#000000' }}>Back to login</Typography></Button>
                    </div>
                </div>
            </Container>
            <div className={classes.paper}>
                <div className={classes.description}>
                    <Typography variant='h4' color='textSecondary'>**You will receive an email with your new password</Typography>
                    <Typography variant='h4' color='textSecondary'>once you receive your new password, a password reset is mandatory</Typography>
                </div>
            </div>
        </React.Fragment>
    )
}

const ForgotPasswordMobile = ({ profile, missing, username, setusername, userToken, setUsertoken, onResetPassword }) => {
    const classes = makeStyles((theme) => ({
        paper: {
            marginTop: theme.spacing(5),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        description: {
            paddingTop: '20px',
            display: "flex",
            flexDirection: "column",
        },
        avatar: {
            margin: theme.spacing(4),
            height: theme.spacing(12),
            width: theme.spacing(12),
        },
        content: {
            width: "100%",
            marginTop: theme.spacing(5),
        },
        button: {
            margin: theme.spacing(2, 0, 0),
        },
    }))()

    return (
        <React.Fragment>
            <Container component="main" maxWidth="xs">
                <div className={classes.paper}>
                    <img className={classes.avatar} src={LogoImg} />
                    <Typography variant="h3" color='textSecondary'>Ericsson Support Portal</Typography>
                    <div className={classes.content}>
                        <TextField autoFocus required fullWidth variant="outlined" size='small' margin="normal" type='text' id="username" label="Username or Email" error={missing['username']} value={username} onChange={(event) => setusername(event.target.value)} onKeyPress={(e) => { e.key === 'Enter' ? document.getElementById('usertoken').focus() : null }} />
                        <TextField autoFocus required fullWidth variant="outlined" size='small' margin="normal" type='number' id="usertoken" label="Authenticator Token" error={missing['token']} value={userToken} onChange={(event) => setUsertoken(event.target.value)} onKeyPress={(e) => { e.key === 'Enter' ? onResetPassword() : null }} />
                        <Button fullWidth variant="contained" size='small' className={classes.button} disabled={profile.status === 'WORKING'} startIcon={profile.status === 'WORKING' ? <CircularProgress size={20} /> : null} onClick={onResetPassword}><Typography variant="h5" style={{ color: profile.status === 'WORKING' ? '#FFFFFF' : '#000000' }}>Reset Password</Typography></Button>
                        <Button fullWidth variant="contained" size='small' className={classes.button} component={CustomRouterLink} to={"/login"} ><Typography variant="h5" style={{ color: '#000000' }}>Back to login</Typography></Button>
                    </div>
                </div>
            </Container>
            <div className={classes.paper}>
                <div className={classes.description}>
                    <Typography variant='h6' color='textSecondary'>**Password reset is <b><i>mandatory</i></b> for new password on login</Typography>
                </div>
            </div>
        </React.Fragment>
    )
}

const ForgotPassword = ({ profile }) => {
    const responsive = responsiveData()

    const [username, setusername] = React.useState("")
    const [userToken, setUsertoken] = React.useState('')

    const [missing, setMissing] = React.useState({ username: false, token: false })
    const [status, setStatus] = React.useState('NEW')

    const snackbarTransition = (props) => {
        return <Slide {...props} direction="left" />;
    }

    const viewProps = {
        profile, missing, status,
        username, setusername,
        userToken, setUsertoken,
        onResetPassword: () => {
            if (username.length > 0 && userToken.length === 6) {
                setMissing({ username: false, token: false })
                setStatus('WORKING')
                IAMAction.forgot_password({ username: username, token: userToken }, setStatus)
            } else {
                setMissing({ username: !(username.length > 0), token: !(userToken.length > 6) })
            }
        },
    }

    return (
        <React.Fragment>
            {responsive.isMobile ? <ForgotPasswordMobile {...viewProps} /> : responsive.isTablet ? <ForgotPasswordTablet {...viewProps} /> : <ForgotPasswordDesktop {...viewProps} />}
            <UnapprovedUser profile={profile} />
            <LockedUser profile={profile} />
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={status === "SUCCESS"} autoHideDuration={10000} onClose={() => setStatus('NEW')} TransitionComponent={snackbarTransition}>
                <MuiAlert elevation={6} onClose={() => setStatus('NEW')} variant="filled" severity={"success"}>Password reset mail sent</MuiAlert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={status === "ERROR"} autoHideDuration={10000} onClose={() => setStatus('NEW')} TransitionComponent={snackbarTransition}>
                <MuiAlert elevation={6} onClose={() => setStatus('NEW')} variant="filled" severity={"error"}>Error while sending password reset mail</MuiAlert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={status === "AUTH_FAILED"} autoHideDuration={10000} onClose={() => setStatus('NEW')} TransitionComponent={snackbarTransition}>
                <MuiAlert elevation={6} onClose={() => setStatus('NEW')} variant="filled" severity={"error"}>Invalid Authentication Token</MuiAlert>
            </Snackbar>
        </React.Fragment>
    )
}

export default ForgotPassword
